import React from "react";

const DeliverShimmer = () => {
  return (
    <>
      <div className="max-w-7xl p-4 mx-auto  mt-8 animate-pulse">
        <div className="border border-[#E5E5E5] rounded-2xl p-4 md:p-10"> 
          {/* Address shimmer */}
          <div className="flex items-start gap-4 sm:gap-5 mb-8">
            <div className="w-5 h-5 rounded bg-gray-300" />
            <div className="h-4 bg-gray-300 rounded w-3/4 sm:w-2/3" />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            {/* Map Box shimmer */}
            <div className="flex-1 h-[160px] rounded-xl bg-gray-300 shadow-md" />

            {/* Info Box shimmer */}
            <div className="flex-1 rounded-xl h-[160px] bg-gray-200 p-4 sm:p-6 lg:p-8">
              <div className="flex justify-between items-center h-full gap-6">
                <div className="flex flex-col justify-center space-y-4 w-full">
                  <div>
                    <div className="h-5 bg-gray-300 rounded w-1/2 mb-2" />
                    <div className="h-3 bg-gray-300 rounded w-1/3" />
                  </div>

                  <div>
                    <div className="h-5 bg-gray-300 rounded w-1/2 mb-2" />
                    <div className="h-3 bg-gray-300 rounded w-1/3" />
                  </div>
                </div>

                {/* Delivery icon shimmer */}
                <div className="w-28 h-28 sm:w-32 sm:h-32 rounded-full bg-gray-300" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeliverShimmer;
